/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import { call, put, takeLatest, select } from 'redux-saga/effects';
import logger from '@tcp/core/src/utils/loggerInstance';
import { setNonInventoryStagSessionFlag } from '@tcp/core/src/reduxStore/actions';
import { setFBTFlag } from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.actions';
import { isApplePayEligible } from '@tcp/core/src/utils/utils';
import { buyItAgainProducts } from '@tcp/core/src/components/features/account/BuyItAgain/container/BuyItAgain.selectors';
import { readCookie } from '@tcp/core/src/utils/cookie.util';
import ABTestAbstractors from '../../../../services/abstractors/common/abTest/abTest';
import { setAbTestData, appendDyAbTestData } from './abTest.actions';
import { FETCH_AB_TEST_DATA, FETCH_DY_ABTESTS_DATA } from './abTest.constants';
import {
  getPointsToNextReward,
  getLowInventoryMonetateExp,
} from '../../../features/CnC/AddedToBag/container/AddedToBag.selectors';
import {
  getIsBOSSswitchEnabled,
  getQuickAddFreeShippingRecsThreshold,
  getQuickAddThreshold,
} from '../../../../reduxStore/selectors/session.selectors';
import { getIsGuest, isPlccUser } from '../../../features/account/User/container/User.selectors';
import BagPageSelector, {
  getECOMStatus,
  getFreeShippingThresholdValue,
  getIsFreeShippingCouponApplied,
  getIsPlccCheckoutEnabled,
  getOrderType,
} from '../../../features/CnC/BagPage/container/BagPage.selectors';
import { getSessionStorage, parseBoolean } from '../../../../utils';
import {
  getDefaultStore,
  getGeoDefaultStore,
} from '../../organisms/ProductPickup/container/ProductPickup.selectors';
import { getLocalStorage, setLocalStorage } from '../../../../utils/localStorageManagement';
import {
  getCartOrderDetails,
  getOrderShipments,
} from '../../../features/CnC/CartItemTile/container/CartItemTile.selectors';
import CheckoutSelector from '../../../features/CnC/Checkout/container/Checkout.selector';
import { getDyABtests } from './utils/dyABTests';

/**
 * @function fetchAbTestData
 * @description This function will call adobe target to get all A/B tests.
 */

function* checkForBossSwitchEligiblity() {
  let isBOSSswitchEnableForSPC = false;

  const isBossSwitch = yield select(getIsBOSSswitchEnabled);
  if (isBossSwitch) {
    const userDefaultStore = yield select(getDefaultStore);
    const geoDefaultStore = yield select(getGeoDefaultStore);
    const orderType = yield select(getOrderType);
    const isBossCartHaveInventory = yield select(BagPageSelector.getIsBOSSCartAvailable);
    const orderItem = yield select(getCartOrderDetails) || {};
    const { orderItems } = JSON.parse(JSON.stringify(orderItem));
    let isCartBossEligible = false;
    isCartBossEligible = orderItems?.every((data) => {
      if (data?.miscInfo && data?.miscInfo?.isBossEligible === false) {
        return false;
      }
      return true;
    });

    const defaultStore =
      userDefaultStore || geoDefaultStore || JSON.parse(getLocalStorage('defaultStore')) || null;
    if (orderType === 'PURE_ECOM') {
      isBOSSswitchEnableForSPC =
        (defaultStore &&
          defaultStore?.storeBossInfo?.isBossEligible &&
          isCartBossEligible &&
          isBossCartHaveInventory) ||
        false;
    } else {
      isBOSSswitchEnableForSPC = false;
    }
    setLocalStorage({ key: 'isBossSwitchEnabled', value: isBOSSswitchEnableForSPC });
    return isBOSSswitchEnableForSPC;
  }
  return false;
}

const getIsUserEligibleForQuickAdd = (
  isFreeShippingCouponApplied,
  quickAddFreeShippingRecsThreshold,
  amountLeftToAttainFreeShipping
) => {
  return (
    !isFreeShippingCouponApplied &&
    quickAddFreeShippingRecsThreshold > 0 &&
    amountLeftToAttainFreeShipping > 0 &&
    amountLeftToAttainFreeShipping <= quickAddFreeShippingRecsThreshold
  );
};

export const checkForDeviceId = () => {
  return Promise.resolve(readCookie('userDeviceId'));
};
// Need to revert this once DY Integreated
// eslint-disable-next-line sonarjs/cognitive-complexity
export function* fetchAbTestData({ payload }) {
  try {
    const isBOSSswitchEnableForSPC = yield call(checkForBossSwitchEligiblity);
    const pointsToNextReward = yield select(getPointsToNextReward);
    const quickAddThreshold = yield select(getQuickAddThreshold);
    const displayLowInvMonetateExp = yield select(getLowInventoryMonetateExp);
    const isGuest = yield select(getIsGuest);
    const isPlccIC = yield select(getIsPlccCheckoutEnabled);
    const isPlccInstantCheckout = !isGuest && isPlccIC;
    const isDefaultApplePayEnabled = isApplePayEligible();
    const isPLCCUser = yield select(isPlccUser);
    const isPlccPriceOnPDP = !isPLCCUser;
    setLocalStorage({ key: 'isPlccPriceOnPDP', value: isPlccPriceOnPDP });
    const isDefaultAfterPay = parseBoolean(getSessionStorage('defaultAfterPay'));
    const biaProducts = yield select(buyItAgainProducts);
    const isBIABagPageEnabled = !isGuest && biaProducts?.length > 0;
    const quickAdd = !isGuest && pointsToNextReward < quickAddThreshold;
    let isUserEligibleForQuickAdd = false;
    const isEcomOrder = yield select(getECOMStatus);
    const shippingMethodId = yield select(CheckoutSelector.getDefaultShipmentID);

    if (payload?.payload?.pathname?.includes('/bag')) {
      const quickAddFreeShippingRecsThreshold = yield select(getQuickAddFreeShippingRecsThreshold);
      const isFreeShippingCouponApplied = yield select(getIsFreeShippingCouponApplied);
      const freeShippingThreshold = yield select(getFreeShippingThresholdValue);
      const shipments = yield select(getOrderShipments);
      const shippingDetails = shipments?.filter((shipment) => {
        if (shipment.size) return shipment.get('c_fromStoreId') === null;
        return shipment?.c_fromStoreId === null;
      })[0];
      const amountLeftToAttainFreeShipping =
        freeShippingThreshold - shippingDetails?.productTotal || 0;
      isUserEligibleForQuickAdd = getIsUserEligibleForQuickAdd(
        isFreeShippingCouponApplied,
        quickAddFreeShippingRecsThreshold,
        amountLeftToAttainFreeShipping
      );
    }

    const userDeviceId = yield call(checkForDeviceId);

    const result = yield call(ABTestAbstractors.getABData, {
      ...payload,
      quickAdd,
      displayLowInvMonetateExp,
      isPlccInstantCheckout,
      isDefaultApplePayEnabled,
      isDefaultAfterPay,
      isBIABagPageEnabled,
      isBOSSswitchEnableForSPC,
      isPlccPriceOnPDP,
      isUserEligibleForQuickAdd,
      userDeviceId,
      isShippingSaved: isEcomOrder && shippingMethodId && !isGuest,
    });
    const {
      payload: { setAbtestScript },
    } = payload;
    if (typeof setAbtestScript === 'function') {
      setAbtestScript(result.abtestScripts);
    }
    yield put(setAbTestData({ abTest: result.parsedAbtestResponse || {}, abTestComplete: true }));
    if (result && result.parsedAbtestResponse && result.parsedAbtestResponse.enableFBTabTest) {
      yield put(setFBTFlag());
    }
    if (
      result &&
      result.parsedAbtestResponse &&
      result.parsedAbtestResponse.isNonInventoryABTestEnabled
    ) {
      yield put(setNonInventoryStagSessionFlag(true));
    }
  } catch (err) {
    logger.error('fetchAbTestData: -', {
      error: err,
      extraData: {
        component: 'fetchAbTestData - Saga',
        payloadRecieved: payload,
      },
    });
  }
}

export function* loadDyABtests(action) {
  const { payload } = action || {};
  const userDeviceId = yield call(checkForDeviceId);
  const isCheckoutPage = payload?.pageName === 'checkout';

  if (isCheckoutPage && userDeviceId) {
    payload.pageAttributes = { suppressCvv: 'true' };
  }

  try {
    const response = yield call(getDyABtests, payload);
    yield put(appendDyAbTestData({ abTest: response || {}, abTestComplete: true }));
  } catch (e) {
    logger.error('Error occurred in DY AB Tests at loadDyABtests method -', {
      error: e,
      extraData: {
        component: 'abTest.saga',
        method: 'loadDyABtests',
        payloadRecieved: payload,
      },
    });
  }
}

/**
 * @function AbtestSaga
 * @description watcher function for getAllAbtest.
 */
function* AbtestSaga() {
  yield takeLatest(FETCH_AB_TEST_DATA, fetchAbTestData);
  yield takeLatest(FETCH_DY_ABTESTS_DATA, loadDyABtests);
}

export default AbtestSaga;
